import { useState, useEffect } from 'react';
import './style.scss'
const SinobusHKEN = () => {
    let isTrue = false;
    useEffect(() => {
        if (isTrue === false) {
            isTrue = true;
            const scriptDiv1 = document.createElement('script');
            scriptDiv1.innerHTML = `{(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MH29QND');}`;
            document.head.appendChild(scriptDiv1);

            const noscript = document.createElement('noscript');
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MH29QND"
            height="0" width="0" style="display:none;visibility:hidden">`;
            document.body.appendChild(noscript);
            document.title = '1對1英文補習|English Tuition Online|Sino-bus';
        }
    }, []);
    const go = () => {
        window.open('https://wa.me/8615309292067?text=%E5%92%A8%E8%AF%A2%E8%8B%B1%E6%96%87');
    }

    return (
        <div className="sinobusHKEN">
            <div onClick={() => { go() }}>
                <img className='hkenImg' src="../assets/sinobusHk/bannerEn.png" alt="" />
            </div>
            <div className="banner2">
                <img src="../assets/sinobusHk/banner2.png" alt="" />
            </div>
            <div className="banner3">
                <div className='banner3-text'>
                    <div className='banner3-content'>
                        <img className='icon' src="../assets/sinobusHk/icon1.png" alt="" />
                        <p>自然拼讀法</p>
                    </div>
                    <div className='banner3-content'>
                        <img className='icon' src="../assets/sinobusHk/icon2.png" alt="" />
                        <p>主题式教學</p>
                    </div>
                </div>
                <div className='banner3-text'>
                    <img className='banner3-img' src="../assets/sinobusHk/left.jpeg" alt="" />
                    <img className='banner3-img' src="../assets/sinobusHk/right.jpeg" alt="" />
                </div>
            </div>
            <div
                id="footer-div"
                style={{
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    textAlign: 'center',
                    transition: 'opacity 0.5s ease',
                }}
            >
                <img className='HKenwts' onClick={() => { go() }} src="../assets/sinobusHk/WhatsAppIcon.jpg" alt="" />
            </div>
        </div>
    )
}
export default SinobusHKEN;